'use strict';
define([], function () {
    return {
        templateUrl: 'app/modules/seospider/components/status-code-doughnut/status-code-doughnut.html',
        bindings: {
            codesCount: '<',
            inAnimation: '<',
            /* The workspace shows this title in the widget head. */
            hideTitle: '<'
        },
        controller: ['$scope', '$mdMedia', function ($scope, $mdMedia) {
            var vm = $scope;
            vm.$mdMedia = $mdMedia;

            $scope.colors = ['#2ed47a', '#e8c84f', '#ff9700'];
            $scope.labels = ["2xx", "3xx", "4xx"];
            $scope.data = [0, 0, 0];
            $scope.chartOpts = {
                fill: false,
                responsive: false,
                aspectRatio: 0.6,
                animation: {},
                maintainAspectRatio: false,
                circumference: 2 * Math.PI,
                rotation: -0.5 * Math.PI,
                cutoutPercentage: 65,
                legend: {
                    display: false,
                    align: 'left',
                    position: 'bottom',
                    labels: {
                        usePointStyle: true
                    },
                },
                title: {
                    display: false,
                    text: 'Status Code',
                    position: 'top',
                    fontStyle: 'bold',
                    fontSize: '14',
                    fontColor: '#130D41'
                },
                elements: {
                    arc: {
                        borderWidth: 1,
                    },
                },
            };

            $scope.$watchCollection('$ctrl.codesCount', function (codesCount) {
                if (codesCount && codesCount.length) {
                    setData(codesCount);
                }
                if (codesCount && !codesCount.length) {
                    $scope.data = [0, 0, 0];
                }
            });
            $scope.$watch('$ctrl.inAnimation', function (inAnimation) {
                if (!inAnimation) {
                    $scope.chartOpts.animation.duration = 0;
                }
            })

            function setData(codes) {
                $scope.data = [0, 0, 0];
                angular.forEach(codes, function (code) {
                    var status = Number(code && code.status);
                    var count = Number(code && code.count) || 0;
                    if (status >= 200 && status < 300) {
                        $scope.data[0] += count;
                    }
                    if (status >= 300 && status < 400) {
                        $scope.data[1] += count;
                    }
                    if (status >= 400) {
                        $scope.data[2] += count;
                    }
                })
            }


        }]
    };
});
